import { render, staticRenderFns } from "./PaperTable.vue?vue&type=template&id=2b06aba4"
import script from "./PaperTable.vue?vue&type=script&lang=js"
export * from "./PaperTable.vue?vue&type=script&lang=js"
import style0 from "./PaperTable.vue?vue&type=style&index=0&id=2b06aba4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports